import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { abridgedclass, lessonnote, moduledetails, modulemedia } from 'src/app/models/module/moduledetails';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { QuillEditorComponent } from 'ngx-quill';
import { DomSanitizer } from '@angular/platform-browser';
import { AddExternalMediaComponent } from '../add-external-media/add-external-media.component';
import { UtilService } from 'src/app/services/util.service';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { FullscreenNoteChrome } from 'src/app/services/fullscreen-note-chrome';

declare const $: any;

@Component({
  selector: 'app-classnote',
  templateUrl: './classnote.component.html',
  styleUrls: ['./classnote.component.css']
})
export class ClassnoteComponent implements OnInit, AfterViewInit, OnDestroy {
  moduleinfo: moduledetails = new moduledetails();
  lessondetails: abridgedclass;
  classid: any;
  lessonnote: Array<lessonnote> = [];
  quill: any = {};
  currentPage: number;
  title: string;
  noteToDelete: Array<lessonnote> = [];
  @ViewChild('addExternalMediaComponent') addExternalMediaComponent: AddExternalMediaComponent;
  @ViewChild('mediaModal') mediaModal: ElementRef;
  @ViewChild('externalMediaModal') externalMediaModal: ElementRef;

  @ViewChild('editor') contentQuillEditor: QuillEditorComponent;
  linkUrl=""
  linkPlaceholder=""

  /* Full-screen editing. The same helper the two readers use, so entering, exiting and
     the fading exit button behave identically across all three note surfaces. The
     surface here is the editor card, so the toolbar and the page buttons come with it —
     only the exit button floats. */
  readonly fs = new FullscreenNoteChrome();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.fs.active) {
      this.fs.set(false);
    }
  }

  ngOnDestroy(): void {
    // The scroll lock is on <body>, which outlives this component.
    this.fs.destroy();
  }
  constructor(private classmanager: ClassmanagementService, private router: ActivatedRoute, private headerinfo: ComponentheaderService, private route: Router, private toastr: ToastrService, private moduleservice: ModulemanagementService, private schoolmanager: SchoolmanagementService, public sanitizer: DomSanitizer, private util: UtilService) { }

  ngAfterViewInit(): void {
    this.contentQuillEditor.onEditorCreated.subscribe(() => {      
      this.quill = this.contentQuillEditor.quillEditor;
      this.loadNotesIntoQuill();
    });
    this.contentQuillEditor.onEditorChanged.subscribe(() => {
      this.quill = this.contentQuillEditor.quillEditor;
    });
  }

  async ngOnInit() {
    this.headerinfo.setHeaderDisplay("Loading...",
      [], []);
    await this.setparams();    
  }

  async setparams() {    
      if (this.router.snapshot.queryParams.classid > 0) {
        this.classid = parseInt(this.router.snapshot.queryParams.classid);
      }      
      this.getLessonNote(this.classid);
      this.getBreadcurmbDetails(this.classid);      
  }
  async getBreadcurmbDetails(classid: any) {
    this.lessondetails = await this.classmanager.getClassDetailsAbridged(classid).toPromise();
    //debugger;
    this.moduleinfo = await this.classmanager.getClassModuleDetails(classid).toPromise();
    //this.schooldetails= await this.schoolmanager.getSchoolInfo(this.moduleinfo.schoolID).toPromise();
    this.headerinfo.setHeaderDisplay("Edit Notes / Videos",
      [
        { displaytext: "School", route: `/user/schoolhome` },
        { displaytext: "Course", route: `/user/moduledetails`, params: { moduleID: this.moduleinfo.id } },
        { displaytext: "Lesson", route: `/user/lesson`, params: { classid: this.classid } },
        { displaytext: 'Edit Notes / Videos', route: this.router.snapshot.url.join('/'), params: this.router.snapshot.queryParams }
      ],
      [{
        displaytext: 'Insert Links/Urls',
        callback: this.addLink.bind(this),
        classes: ['fas', 'fa-link'],
      },
      { displaytext: 'Insert From Media Library', callback: this.insertFromMediaLibrary.bind(this), classes: ['fas', 'fa-photo-video'], disabled: !await this.util.hasFeature(FeatureGroups.MEDIA_LIBRARY), featureGroup: FeatureGroups.MEDIA_LIBRARY },
      { displaytext: 'Add Video from Youtube/Vimeo', callback: this.addFromYoutube.bind(this), classes: ['fab', 'fa-youtube'], disabled: !await this.util.hasFeature(FeatureGroups.YOUTUBE_VIMEO_VIDEOS), featureGroup: FeatureGroups.YOUTUBE_VIMEO_VIDEOS }]);
  }

  loadNotesIntoQuill(page: number = 1){
    if(this.quill?.root && this.lessonnote[page - 1]?.content){
      this.quill.root.innerHTML = this.lessonnote[page -1].content;
      this.title = this.lessonnote[page -1].title.length > 0 ? this.lessonnote[page -1].title : "Section " + page ;
    }
    else if (!this.lessonnote[page - 1] && this.quill?.root){ // loads an empty and new page
      this.lessonnote[page -1]= new lessonnote();
      this.lessonnote[page - 1].schoolModuleClassID = this.classid; 
      this.quill.root.innerHTML = "";
      this.title = "Section " + page;
    }
    else if(!this.lessonnote[page - 1]?.content && this.quill?.root){
      this.lessonnote[page - 1].schoolModuleClassID = this.classid; 
      this.quill.root.innerHTML = "";
      this.title = "Section " + page;
    }
    this.currentPage = page;
  }

  async getLessonNote(classid: number) {    
    this.lessonnote = await this.classmanager.getClassNote(classid).toPromise();

    if(this.lessonnote.length > 0){
      this.loadNotesIntoQuill();      
    }
    else
    {
      this.lessonnote[0]=new lessonnote();
      this.lessonnote[0].schoolModuleClassID=classid;
    }
  }

  async tempSaveCurrentNote(page: number) {   
    this.lessonnote[page - 1].content = this.quill.root.innerHTML;   
    this.lessonnote [page - 1].title = this.title.includes('Section') ? "" : this.title;
    this.title = "";
  }

  async saveNotes(){
    await this.tempSaveCurrentNote(this.currentPage);    
    if(this.noteToDelete.length > 0){
      this.noteToDelete.forEach(async n => await this.classmanager.deleteclassnote(this.classid, n.id).toPromise())
    }
    //set pages
    for(var i = 0; i < this.lessonnote.length; i++){
      this.lessonnote[i].page = i + 1;
    }
    await this.classmanager.addeditclassnote(this.lessonnote, this.classid).toPromise();
    this.toastr.success('Note saved');
    this.goback();
  }
  goback() {
    this.route.navigate(['/user/lesson'], { queryParams: { classid: this.classid, moduleid: this.moduleinfo.id } });
  }
  async nextPage(){
    await this.tempSaveCurrentNote(this.currentPage);
    this.currentPage = this.currentPage + 1;
    this.loadNotesIntoQuill(this.currentPage);  
  }
  async previousPage(){
    await this.tempSaveCurrentNote(this.currentPage);
    this.currentPage = this.currentPage - 1;
    this.loadNotesIntoQuill(this.currentPage);
  }
  async addPage(){
    let newNote =new lessonnote();
    newNote.schoolModuleClassID= this.classid;   
    this.lessonnote.splice(this.currentPage, 0, newNote);
    this.tempSaveCurrentNote(this.currentPage);
    this.currentPage += 1;
    this.loadNotesIntoQuill(this.currentPage);    
  }
  async preDeletePage(){
    $('#deleteLessonnote').modal('hide');

    this.noteToDelete.push(this.lessonnote[this.currentPage - 1]);
    this.lessonnote.splice(this.currentPage - 1, 1);
    this.toastr.success("Page removed!. Save to apply changes");
    this.loadNotesIntoQuill();
  }
  popconfirmdeletenote() {
    $('#deleteLessonnote').modal('show');
  }
  insertFromMediaLibrary(){
    //display modal here
    $(this.mediaModal.nativeElement).modal('show');
  }

  addFromYoutube() {
    $(this.externalMediaModal.nativeElement).modal('show');
  }

  closeExternalMediaModal() {
    this.addExternalMediaComponent.clear();
    $(this.externalMediaModal.nativeElement).modal('hide');
  }

  insertMediaUrl(playerurl) {
    const range = this.quill.getSelection();
    let index = 0;

    if (range !== null) {
      index = range.index;
    } else {
      index = this.quill.root.innerHTML.length - 1;
      //this.quill.container.innerHTML += "<p></p>";
    }
    //debugger;
    //this.quill.insertEmbed(index, 'media', media.playerurl);

    this.quill.insertEmbed(index, 'media', playerurl);
    //const playerurl = `${location.protocol}//${location.hostname}:${location.port}${media.playerurl}`;
    //this.quill.root.innerHTML += `<iframe src="${playerurl}" class="mediaiframe"></iframe>`;
    this.quill.root.innerHTML += "<p></p>";
  }

  mediaSelected(media: modulemedia) {
    //add to the notes here
    //debugger;
    const playerurl = `${media.playerurl}`;

    this.insertMediaUrl(playerurl);

    //$("#mediaModal").modal('hide');
    $(this.mediaModal.nativeElement).modal('hide');
    //console.log(media);
  }

  externalMediaSelected() {
    const mediaurl = this.addExternalMediaComponent.iframeurl;
    if (mediaurl) {
      this.insertMediaUrl(mediaurl);
      this.addExternalMediaComponent.clear();
      $(this.externalMediaModal.nativeElement).modal('hide');
    }
  }

  addLink() {
    $('#urlLinkModal').modal('show');
  }

  closeLink() {
    this.linkPlaceholder='';
    this.linkUrl = '';
    $('#urlLinkModal').modal('hide');
  }
  insertLinkUrl() {
    this.quill.root.innerHTML += `<a href="${this.linkUrl}">${this.linkPlaceholder}</a>`;
    this.closeLink();
  }
}
